import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Navbar, Button, OverlayTrigger, Popover} from 'react-bootstrap';
import {injectIntl} from 'react-intl';

import Icon from 'components/ui/element/Icon';
import MonthSelector from 'components/ui/form/dates/month/MonthSelector';
import YearSelector from 'components/ui/form/dates/year/YearSelector';

import 'style/components/ui/form/dates/month/month-dropdown.scss';

const
    DAY = 1,
    PANEL_MONTH = 'month',
    PANEL_YEAR = 'year',
    PANELS = {PANEL_MONTH,PANEL_YEAR};

/** Component to select a month using a dropdown calendar component */
class MonthDropdown extends Component {

    static propTypes = {
        selectedDay: PropTypes.number, // The timestamp of the date to show
        title:       PropTypes.string, // The title for the Dropdown
        onChange:    PropTypes.func // Listener for when the date is changed
    };

    state = {
        value: new Date(), // The selected month
        panel: PANELS.PANEL_MONTH // The shown panel
    };

    /**
     * Init the state and set this to handlers
     */
    componentWillMount() {
        const {selectedDay} = this.props;


        this.setState({
            value: selectedDay ? new Date(selectedDay) : new Date()
        });

        this.handleClickMonthTitle = this.handleClickMonthTitle.bind(this);
        this.handleClickYearTitle = this.handleClickYearTitle.bind(this);
        this.handleClickMonthMenu = this.handleClickMonthMenu.bind(this);
        this.handleClickMonth = this.handleClickMonth.bind(this);
        this.handleClickYear = this.handleClickYear.bind(this);
    }

    /**
     * Update the value of the state when the value of the props is changed
     * @param {Object} nextProps The new props to add to the component
     */
    componentWillReceiveProps(nextProps) {
        const {selectedDay} = this.props;

        if (nextProps.selectedDay !== selectedDay) {
            this.setState({
                value: nextProps.selectedDay ? new Date(nextProps.selectedDay) : new Date(),
                panel: PANELS.PANEL_MONTH
            });
        }
    }

    /**
     * Change to year panel when month title is clicked
     */
    handleClickMonthTitle() {
        this.setState({
            panel: PANELS.PANEL_YEAR
        });
    }

    /**
     * Change to month panel when year title is clicked
     */
    handleClickYearTitle() {
        this.setState({
            panel: PANELS.PANEL_MONTH
        });
    }

    /**
     * Change the year when month menu arrows are clicked
     * @param {number} diff The diff to apply to the year in the change
     * @returns {boolean} return true when the event must break the chain
     */
    handleClickMonthMenu(diff) {
        const
            today = new Date(),
            { value } = this.state,
            newYear = value.getFullYear() + diff,
            maxYear = today.getFullYear(),
            minYear = maxYear - YearSelector.DEFAULT_MIN_YEAR;

        today.setDate(DAY);
        today.setMonth(value.getMonth());
        if (newYear <= maxYear && newYear >= minYear) {
            today.setFullYear(newYear);
            this.setState({
                value: today
            });
        } else {
            return false;
        }

        return true;
    }

    renderText(date) {
        const {intl:{ formatDate, formatMessage}} = this.props;

        if (date) {
            const formattedDate = formatDate(date, {
                year:  'numeric',
                month: 'short'
            });

            return <span>{formattedDate}</span>;

        }

        return <span>{formatMessage({id: 'label.notavailable'})}</span>;
    }

    /**
     * Change the date when a month is clicked also close the overlay
     * @param {object} month The selected month object
     */
    handleClickMonth(month) {
        const
            { value } = this.state,
            { onChange } = this.props,
            newDate = new Date(value.getTime());

        newDate.setMonth(month.id);

        this.setState({
            value: newDate
        });

        this.refs.overlay.hide();

        onChange && onChange(newDate);
    }

    /**
     * Change the date when a year is clicked also goes to month panel
     * @param year The selected year object
     */
    handleClickYear(year) {
        const
            { value } = this.state,
            { onChange } = this.props,
            newDate = new Date(value.getTime());

        newDate.setFullYear(year.id);

        this.setState({
            value: newDate,
            panel: PANELS.PANEL_MONTH
        });

        onChange && onChange(newDate);
    }

    renderPanel() {
        const {selectedDay} = this.props;
        const { panel, value } = this.state;

        if (panel === PANELS.PANEL_MONTH) {
            const defaultValue = value.getMonth();

            return (
                <MonthSelector
                    textMenu={`${value.getFullYear()}`}
                    defaultValue={defaultValue}
                    selectedDate={selectedDay}
                    onChange={this.handleClickMonth}
                    onClickTitle={this.handleClickMonthTitle}
                    onClickMenu={this.handleClickMonthMenu}
                />
            );
        } else if (panel === PANELS.PANEL_YEAR) {
            const defaultValue = value.getFullYear();

            return (
                <YearSelector
                    defaultValue={defaultValue}
                    onChange={this.handleClickYear}
                    onClickTitle={this.handleClickYearTitle}
                />
            );
        }

        return null;
    }

    render() {
        const {selectedDay} = this.props;

        return (
            <Navbar.Form className="month-dropdown">
                <OverlayTrigger
                    ref="overlay"
                    rootClose
                    trigger="click"
                    placement="bottom"
                    overlay={
                        <Popover id="tooltip" className="month-dropdown-popover">
                            {this.renderPanel()}
                        </Popover>
                    }
                >
                    <Button
                        ref="button"
                        onClick={e => { e.stopPropagation() }}
                    >
                        <Icon name="calendar-o"/>
                        {this.renderText(selectedDay)}
                        <span className="caret" />
                    </Button>

                </OverlayTrigger>
            </Navbar.Form>
        );
    }
}

export default injectIntl(MonthDropdown);



// WEBPACK FOOTER //
// ./src/components/ui/form/dates/month/MonthDropdown.jsx